import { IGetMyTrainingStatisticsResponse } from "api/models/response/IGetMyTrainingStatisticsResponse"
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall"
import { getMyTrainingStatistics } from "api/services/lesson-service"
import { useCallback } from "react";
import { UserLessonStatistics } from "models/UserLessonStatistics";
import { IGetUserTrainingInfoRequest } from "api/models/request/IGetUserTrainingInfoRequest";

export const useGetMyTrainingInfo = () => {
    const { callAPI, loading } = useWorkspaceApiCall<IGetUserTrainingInfoRequest | undefined, IGetMyTrainingStatisticsResponse>(getMyTrainingStatistics, '', 'getMyTrainingStatistics.error');

    const getMyTrainingStatisticsApiCall = useCallback(async (userId: string | undefined) => {
        const res = await callAPI({ userId });
        if (res?.status === 200) {
            const statisticsResp = res.data;

            if (statisticsResp) {

                const progressesByLessonId = statisticsResp.lessonProgresses.reduce((acc: { [key: string]: typeof statisticsResp.lessonProgresses }, lp) => {
                    (acc[lp.lessonVersion.lessonId] = acc[lp.lessonVersion.lessonId] || []).push(lp);
                    return acc;
                }, {});
                
                const latestProgressesForLesson = Object.values(progressesByLessonId).map(progresses => {
                    const highestVersion = progresses.reduce((max, lp) => {
                        return max.lessonVersion.version > lp.lessonVersion.version ? max : lp;
                    }).lessonVersion.version;
                
                    const highestVersionGroup = progresses.filter(lp => lp.lessonVersion.version === highestVersion);

                    highestVersionGroup.sort((a, b) => b.createdAt.localeCompare(a.createdAt));
                
                    return highestVersionGroup[0];
                });

                let totalScoredPoints = latestProgressesForLesson.reduce((total, lp) => total + lp.pointsScored, 0);
                let totalMaxPoints = latestProgressesForLesson.reduce((total, lp) => total + lp.lessonVersion.maxPoints, 0);

                const userStatistics: UserLessonStatistics = {
                    allProgresses: statisticsResp.lessonProgresses,
                    lessons: statisticsResp.lessons,
                    lessonsCount: statisticsResp.lessons.length,
                    allLessonsProgress: totalMaxPoints !== 0 ? parseFloat((totalScoredPoints / totalMaxPoints * 100).toFixed(1)) : 0,
                    sumOfPointsScored: latestProgressesForLesson.map(lp => lp.pointsScored).reduce((a, b) => a + b, 0),
                    sumOfMaxPoints: latestProgressesForLesson.map(lp => lp.lessonVersion.maxPoints).reduce((a, b) => a + b, 0),
                    actualProgresses: latestProgressesForLesson.sort((a, b) => a.lessonVersion.lessonName.localeCompare(b.lessonVersion.lessonName)),
                    placeInOrganizationRanking: statisticsResp.placeInWorkspace,
                    organizationParticipantsCount: statisticsResp.participantsInWorkspaceCount   
                }

                return userStatistics;
            }            
        }
    }, [callAPI]);
    
    return { getMyTrainingStatisticsApiCall, getStatisticsPending: loading}
}